<template>
  <div>
    <v-dialog persistent :value="addModal" width="500">
      <v-card>
        <v-card-title>{{'Create a new colour ' + (form.name ? form.name : '')}}</v-card-title>
        <v-card-text>
          <div>
            <v-form ref="addForm" lazy-validation>
              <v-text-field
                v-model="form.name"
                :rules="textValidation"
                name="Name"
                label="Name"
                required
                validate-on-blur
                type="text"
              ></v-text-field>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            @click="closeModal()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
            style="text-transform: capitalize;"
          >Cancel</v-btn>
          <v-btn
            @click="add()"
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0 primary' : 'ml-0 primary'"
            style="text-transform: capitalize;"
          >Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ColorAPI } from '@/clients/product/color.api'
import Helper from '@/utility/Helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      textValidation: [
        v => !!v || 'Field is required',
        v => Helper.validateSpace(v) || `Blank value.`
      ],
      form: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      addModal: 'color/addPop'
    })
  },

  methods: {
    /**
     * Add new data
     */
    async add() {
      if (this.$refs['addForm'].validate()) {
        try {
          // Trigger api
          this.spinner(true)
          let res = await ColorAPI.insert(this.form)
          this.spinner(false)
          if (res.status === 200) {
            this.closeModal()
          }
          // Display message alert
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Close add  popup
     */
    closeModal() {
      this.setAddPopup(false)
      Helper.setObjValueEmpty(this.form)
      this.$refs.addForm.reset()
    },

    ...mapActions({
      setAddPopup: 'color/setAddPop'
    })
  }
}
</script>
